import { Outlet, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { CommandPalette } from './CommandPalette'
import { navItemForPath } from '@/lib/navigation'
import { AdminErrorBoundary } from '@/components/AdminErrorBoundary'
import { useAuth } from '@/contexts/AuthContext'

export function AdminLayout() {
  const { pathname } = useLocation()
  const { permissions } = useAuth()
  const currentItem = navItemForPath(pathname, permissions)
  const [navOpen, setNavOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  useEffect(() => {
    if (!navOpen) return
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setNavOpen(false); document.querySelector<HTMLButtonElement>('.admin-mobile-menu')?.focus() }
    }
    window.addEventListener('keydown', closeOnEscape)
    return () => window.removeEventListener('keydown', closeOnEscape)
  }, [navOpen])

  useEffect(() => {
    const openSearch = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault()
        setSearchOpen(true)
      }
    }
    window.addEventListener('keydown', openSearch)
    return () => window.removeEventListener('keydown', openSearch)
  }, [])

  return (
    <div className="admin-shell">
      <a className="admin-skip-link" href="#admin-main">Skip to content</a>
      <button type="button" tabIndex={-1} className={`admin-nav-backdrop ${navOpen ? 'is-open' : ''}`} onClick={() => setNavOpen(false)} aria-label="Close navigation" />
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="admin-main">
        <Topbar title={currentItem?.label} section={currentItem?.section} onOpenNav={() => setNavOpen(true)} onOpenSearch={() => setSearchOpen(true)} />
        <main className="admin-content" id="admin-main">
          <div className="admin-content-inner">
            <AdminErrorBoundary key={pathname}>
              <Outlet />
            </AdminErrorBoundary>
          </div>
        </main>
      </div>
      <CommandPalette open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  )
}
